import firebase from 'firebase'
import { db } from '../config/firebaseconfig'
import disarrayify from './disarrayify'

const uuid = require('uuid/v1')

//Need to add created by and permissions to items (user & company) 

export default function saveContentItem({
  itemId, 
  contentType, 
  itemType, 
  shuffle, 
  question, 
  answers, 
  startingLetter, 
  nodeTags, 
  name, 
  code, 
  passage, 
  passageId, 
  videoFeedback, 
  videoFeedbackThumbnail 
}) {
  return new Promise((resolve, reject) => {
    const date = new Date
    const timestamp = date.getTime()
    const answersArray = answers.slice(0)
    let answersObj = {}
    answersObj = disarrayify(answersArray, 'answer')
    let passageIdString
    if (passage && !passageId) {
      passageIdString = uuid()
    } else if (passageId) {
      passageIdString = passageId
    } else {
      passageIdString = ''
    }

    if (passageIdString) {
      const batch = db.batch()
      const itemRef = db.collection('contentItems').doc(itemId)
      const passageRef = db.collection('contentItemPassages').doc(passageIdString)
      batch.set(itemRef, {
        itemId,
        contentType,
        itemType,
        shuffle,
        question,
        answers: answersObj,
        createdDate: timestamp,
        lastModifiedDate: timestamp,
        startingLetter,
        nodeTags,
        name,
        code,
        passageId: passageIdString,
        videoFeedback,
        videoFeedbackThumbnail,
      }, {merge: true})
      batch.set(passageRef, {text: passage}, {merge: true})
      batch.commit()
        .then( () => {
          resolve(itemId)
        })
        .catch( (error) => {
          console.log('error saveContentItem: ', error)
          reject('db/content/items saveContentItem set failed')
        })
    } else {
      db.collection('contentItems').doc(itemId).set({
        itemId,
        contentType,
        itemType,
        shuffle,
        question,
        answers: answersObj,
        createdDate: timestamp,
        lastModifiedDate: timestamp,
        startingLetter,
        nodeTags,
        name,
        code,
        passageId: passageIdString,
        videoFeedback,
        videoFeedbackThumbnail,
      }, {merge: true})
      .then( () => {
        resolve(itemId)
      })
      .catch( (error) => {
        console.log('error saveContentItem: ', error)
        reject('db/content/items saveContentItem set failed')
      })
    }
  })
}








// WEBPACK FOOTER //
// ./src/helpers/saveContentItem.js